module.exports = __webpack_public_path__ + "static/media/commercial_insurance.61989c82.png";